import React from 'react';

function CrmPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>CRM</h1>
      <p>Page `fhc-crm.html` convertie en composant React.</p>
    </div>
  );
}

export default CrmPage;
